import React, { Component } from 'react';
import { TabPane } from 'reactstrap';
import { CollapsibleCard } from '../shared/CollapsibleCard';
import { UserDataService } from '../services/UserDataService';
import { YesNoForm } from '../shared/YesNoForm';

export class Consent extends Component {
    // Flag to check if the component has been mounted
    _isMounted = false;

    constructor(props) {
        super(props);
        this.userDataService = new UserDataService();
        this.changeW2Consent = this.changeW2Consent.bind(this);
        this.changeApdConsent = this.changeApdConsent.bind(this);
        this.getUserData = this.getUserData.bind(this);
        this.state = {
            'w2Consent': props.w2Consent,
            'apdConsent': props.apdConsent,
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

  changeW2Consent(consent) {
    return this.userDataService.updateW2Consent(consent)
        .then(_ => {
            if (this._isMounted) {
                this.setState({ w2Consent: consent });
                this.getUserData();
            }
      });
  }

  changeApdConsent(consent) {
    return this.userDataService.updateApdConsent(consent)
        .then(() => {
            if (this._isMounted) {
                this.setState({ apdConsent: consent });
                this.getUserData();
            }
      });
  }

  getUserData() {
    this.props.getUserData()
        .then(data => {
            if (this._isMounted) {
                console.log('---getUserData in Consent.jsx---');
                console.log(data);
                this.setState({ w2Consent: data.w2Consent, apdConsent: data.apdConsent });
            }
      });
  }

  render() {
    const { w2Consent, apdConsent } = this.state;
    const w2FormProps = { onSubmit: this.changeW2Consent, yesnovalue: w2Consent };
    const apdFormProps = { onSubmit: this.changeApdConsent, yesnovalue: apdConsent };
    return (
      <TabPane tabId='5'>
        <CollapsibleCard title='Automatic Paid Deposit (APD) / Payroll Stub'>
          <p>
            Please select the check below to indicate whether you want to receive any future APD/Payroll Stub electronically or in a paper version. If you select to receive an electronic version of your APDs and subsequently decide to revoke your selection, you must return to this page and uncheck the box.
            If you consent to receive your APD/Payroll Stub electronically, you will not receive any future paper version of your APD(s)/Payroll Stub(s). You agree to be responsible to print all copies necessary.
            If you do not consent to receive your APD/Payroll Stub electronically, you will receive a paper version of any future APD(s)/Payroll Stub(s).
                </p>
          <p>
            <strong>
              I consent to receive any future APD(s)/Payroll Stub electronically	I acknowledge and understand the instructions provided to me.
                        </strong>
          </p>
          <YesNoForm {...apdFormProps} />
        </CollapsibleCard>
        <CollapsibleCard title='Electronic W-2'>
          <p>
            Please select the check below to indicate whether you want to receive your W-2 electronically or a paper version. If you select to receive an electronic version of your W-2 form and subsequently decide to revoke your selection, you must return to this page and uncheck the box.
            If you consent to receive your W-2 electronically, you will not receive a paper version of your W-2. You agree to be responsible to print all copies necessary for tax filing and any other purposes.
            If you do not consent to receive your W-2 electronically, a paper version will be printed and mailed to you each year.
                    </p>
          <ul>
            <li>Your W-2 can be accessed using any computer with internet access.</li>
            <li>You may retrieve your W-2 form via "W-2 Forms" tab within this Employee Portal.</li>
            <li>Your electronic W-2 will be available by January 31 each year that your consent is in force.</li>
            <li>If you file your tax returns on paper, you will be required to print multiple copies of the electronic W-2 and attach it to your federal, state and local income tax returns.</li>
            <li>Federal Regulations require that your current year W-2 be available online until October 15th of the current year. Current and past W-2 forms will remain to be available until you decide to revoke your consent selection or this service is no longer supported.</li>
          </ul>
          <p>
            If you check the box below to receive your W-2 electronically, your selection will be valid all subsequent years unless revoked by you, this service is not supported in a future tax year.
                    </p>
          <p>
            If after consenting to receive your W-2 electronically in any year, you decide to receive a paper version you must uncheck the box below before January 15th. Any revocation of consent after this date will be effective for subsequent tax years.
                    </p>
          <p>
            If you wish to receive a paper copy of your W-2 after the January 15th deadline, you must first revoke your consent by returning to this page and unchecking the box. Then you must submit a "Request for IRS Form W-2" to your payroll department for processing. No paper copies of W-2's will be printed for any employee who has elected to receive their W-2 electronically.
                    </p>
          <p>
            <strong>
              I consent to receive W-2 electronically	I understand the instructions provided to me for accessing and printing my electronic W-2 form.
                        </strong>
          </p>
          <YesNoForm {...w2FormProps} />
        </CollapsibleCard>
      </TabPane>
    );
  }
}